// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__box--ATxKH {
  width: 100%;
  overflow: auto;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__table--DhPAH {
  border-collapse: collapse;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__table--DhPAH td {
  border: thin solid silver;
  padding: 4px 8px;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__button--oPCCX {
  border: none;
  min-height: 32px;
  min-width: 32px;
  height: fit-content;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #fff;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__red--tHf65 {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Settings/Bom3MatrixEdit/Bom3MatrixEdit.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;AACF;AACA;EACE,yBAAA;AACF;AAFA;EAGI,yBAAA;EACA,gBAAA;AAEJ;AACA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACF;AACA;EACE,UAAA;AACF","sourcesContent":[".box {\n  width: 100%;\n  overflow: auto;\n}\n.table {\n  border-collapse: collapse;\n  td {\n    border: thin solid silver;\n    padding: 4px 8px;\n  }\n}\n.button {\n  border: none;\n  min-height: 32px;\n  min-width: 32px;\n  height: fit-content;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: #fff;\n}\n.red {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__box--ATxKH`,
	"table": `src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__table--DhPAH`,
	"button": `src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__button--oPCCX`,
	"red": `src-businessServices-services-bsBom3-Bom3Settings-Bom3MatrixEdit-Bom3MatrixEdit-module__red--tHf65`
};
export default ___CSS_LOADER_EXPORT___;
